import React from "react";
import CustomInput from "../../../components/CustomInput/CustomInput";
import styles from "./AdminLogin.module.scss";
import CustomButton from "../../../components/CustomButton/CustomButton";

const AdminLogin = () => {
  return (
    <div className={styles.adminLoginForm}>
      <h2>Admin</h2>
      <CustomInput label={"Login"} placeholder={"Your login"} />
      <CustomInput label={"Password"} placeholder={"Your password"} />
      <CustomButton blue>Login</CustomButton>
    </div>
  );
};

export default AdminLogin;
